export default __webpack_public_path__ + "static/media/qb_mod_icon.ad865a27.svg";